<template>
  <div class="card height-100">
    <header class="header-card">
      <p>
        {{ $t('addEditTiers.titres.commande')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-narrow">
          <b-field :label="$t('addEditTiers.commande.nombreMoisPreavis')">
            <input-currency type="number" class="is-220px-width"
               v-model="tiers.nombreMoisPreavis">
            </input-currency>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import inputCurrency from '@/components/general/inputCurrency';

export default {
  components: {
    inputCurrency,
  },
  props: {
    tiers: {
      type: Object,
      required: true,
    },
  },
};
</script>
